import ScrollProgress from "@/components/landing/ScrollProgress";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustedBy from "@/components/landing/TrustedBy";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import Benefits from "@/components/landing/Benefits";
import WhoItsFor from "@/components/landing/WhoItsFor";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyInvoquity from "@/components/landing/WhyInvoquity";
import Statistics from "@/components/landing/Statistics";
import FAQ from "@/components/landing/FAQ";
import EarlyAccessForm from "@/components/landing/EarlyAccessForm";
import Footer from "@/components/landing/Footer";
import FloatingCTA from "@/components/landing/FloatingCTA";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative overflow-x-hidden bg-slate-50 text-slate-900">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <TrustedBy />
      <Problem />
      <Solution />
      <Benefits />
      <WhoItsFor />
      <HowItWorks />
      <WhyInvoquity />
      <Statistics />
      <FAQ />
      <EarlyAccessForm />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
